import { SVGProps, Ref, forwardRef } from 'react';

export const TrolleyFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m16 1.126-.362 1.353-2.852-.763-2.495 9.313a2.666 2.666 0 0 1 1.233 2.994l-.084.26a2.667 2.667 0 0 1-3.181 1.625l-.26-.083a2.67 2.67 0 0 1-1.715-2.482l-3.51-.94c-.407-.11-.654-.175-.84-.202a.8.8 0 0 0-.184-.009l-.006.002a.3.3 0 0 0-.056.033l-.005.004-.014.018a1 1 0 0 0-.071.146c-.07.175-.137.422-.245.828L0 12.86l.01-.035.003-.01c.095-.356.181-.679.283-.935.112-.282.273-.568.563-.781q.15-.111.322-.186c.33-.145.657-.142.957-.098.157.024.333.063.52.11L3.686 7.09l.011-.045c.234-.871.428-1.594.657-2.145.242-.579.563-1.067 1.107-1.381s1.127-.348 1.75-.268c.59.076 1.31.269 2.177.5l.053.016 1.256.336L11.797 0zM9.277 12.109a1.267 1.267 0 1 0-.654 2.448 1.267 1.267 0 0 0 .654-2.448"
                fill="currentColor"
            />
        </g>
    </svg>
));
TrolleyFilledSize16Glyph.displayName = 'TrolleyFilledSize16Glyph';
